import Matrix from "./Matrix";

export default Matrix;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/Matrix/index.js